import { render, staticRenderFns } from "./home-mzy.vue?vue&type=template&id=1754cd3d&scoped=true&"
import script from "./home-mzy.vue?vue&type=script&lang=ts&"
export * from "./home-mzy.vue?vue&type=script&lang=ts&"
import style0 from "./home-mzy.vue?vue&type=style&index=0&id=1754cd3d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1754cd3d",
  null
  
)

export default component.exports